import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';
import { layoutConfig } from 'src/common/layout/config';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';

export const useLayoutConfiguration = () => {
  const { isMobile } = useAppUI();
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const { defaultLayout } = layoutConfig[subdomain];

  function getSupportButtonPosition(): 'header' | 'floating' {
    return isMobile ? 'header' : 'floating';
  }

  return {
    showHeaderBrand: defaultLayout.headerBrand,
    showBottomNav: isMobile && defaultLayout.navigation,
    showHeaderNavigation: !isMobile && defaultLayout.navigation,
    showAddressSelector: defaultLayout.headerAddress,
    showSearch: defaultLayout.searchBar,
    defaultLayout,
    supportButtonPosition: defaultLayout.supportButton
      ? getSupportButtonPosition()
      : null,
    showLayoutTimer: defaultLayout.layoutTimer,
    showMobileHeaderBrand: defaultLayout.mobileHeaderBrand,
    showCoupons: defaultLayout.discountCoupons,
    showAddressName: defaultLayout.showAddressName,
  };
};
